import React from 'react'
import { Button, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TextField, Dialog, AppBar } from '@material-ui/core'
import { useEffect } from 'react'
import { Edit, Search, Close, Delete } from '@material-ui/icons'
import queryparse from 'querystring'
import { useHistory } from 'react-router-dom'
const COMPARE = ["Lower", "Equal", "Greater", "LowerEquals", "GreaterEqual"]
export default function Gifts({ api }) {
    const [search, setSearch] = React.useState('')
    const [reward, setReward] = React.useState('')
    const [gifts, setRewards] = React.useState([])
    const [key, setKey] = React.useState('level')
    const [value, setValue] = React.useState('')
    const [comparisionType, setComparisionType] = React.useState(0)
    const [rewardName, setrewardName] = React.useState('')
    const [desc, setDesc] = React.useState('')
    // const [giftType, setGiftType] = React.useState(0)
    // const [giftPrice, setGiftPrice] = React.useState(1)
    const [showDialog, setShowDialog] = React.useState(false)
    const [id, setId] = React.useState('')
    const [type, setType] = React.useState(0)
    const pointer = Number(queryparse.parse(window.location.search)["?skip"] || 0)
    const history = useHistory()
    useEffect(() => {
        api.axios.get("rewards")
            .then((rewards) => {
                setRewards(rewards);
            })
            .catch(e => console.log(e))

    }, [])
    return (
        <div>
            <Dialog open={showDialog} fullScreen={true}>
                <AppBar style={{ padding: 15 }}>Reward {type === 0 ? 'Add' : 'Edit'}</AppBar>
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: 65, marginLeft: 10, marginRight: 10 }}>
                    <TextField value={rewardName} onChange={e => setrewardName(e.target.value)} variant="outlined" fullWidth label="Reward name" />
                    <br />
                    <TextField multiline={true} rows={5} value={desc} onChange={e => setDesc(e.target.value)} variant="outlined" fullWidth label="Description" />
                    <br />
                    <select style={{ padding: 7 }} value={key} onChange={e => setKey(e.target.value)}>
                        <option value="level">level</option>
                        <option value="stats.totalGiftSend">Gift send</option>
                        <option value="stats.totalGiftReceived">Gift Receive</option>
                        <option value="stats.totalGamePlayed">Total Game Played</option>
                    </select>
                    <br />

                    <select style={{ padding: 7 }} value={comparisionType} onChange={e => setComparisionType(e.target.value)}>
                        {COMPARE.map((c, i) => <option value={i}>{c}</option>)}
                    </select>
                    <br />
                    <TextField placeholder="Enter value" type="number" value={value} onChange={e => setValue(e.target.value)} />
                    <br />
                    <TextField placeholder="Enter reward" type="number" value={reward} onChange={e => setReward(e.target.value)} />
                    <br />
                    <div>
                        <Button
                            disabled={rewardName.trim().length === 0 || reward < 1}
                            onClick={e => {
                                api.axios.post(type === 0 ? 'rewards/add' : 'rewards/edit/' + id, {
                                    name: rewardName,
                                    key,
                                    value,
                                    reward,
                                    comparisionType,
                                    desc
                                })
                                    .then(d => {
                                        api.showSnack(`Gift ${type === 0 ? 'added' : 'edited'} successfully.`, 'success')
                                        var removed = gifts.filter(x => x._id !== d._id);
                                        setRewards([d, ...removed])
                                        setShowDialog(false)
                                    })
                                    .catch(e => api.showSnack(e.error || 'Something went wrong.'))

                            }} variant="outlined" color="primary">Save</Button>
                        &nbsp;&nbsp;
                        <Button onClick={e => setShowDialog(false)} variant="outlined" color="secondary">Cancel</Button>

                    </div>

                </div>
            </Dialog>
            <div style={{ display: 'flex', flexDirection: 'row-reverse', margin: 10 }}>
                <Button onClick={e => {
                    setType(0)
                    setShowDialog(true)
                }} variant="outlined" color="primary">Add Reward</Button>
                &nbsp; &nbsp;
                {window.location.search !== "" && <IconButton><Close onClick={e => window.location = "?"} /></IconButton>}
                <IconButton><Search onClick={e => window.location = "?search=" + search} /></IconButton>
                <TextField value={search} onChange={e => setSearch(e.target.value)} label="Search" />

            </div>
            <Table >
                <TableHead>
                    <TableRow>
                        <TableCell>Reward Name</TableCell>
                        <TableCell>Reward reward</TableCell>
                        <TableCell>Key</TableCell>
                        <TableCell>Comparision Type</TableCell>
                        <TableCell>Value</TableCell>
                        <TableCell>ACTIONS</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {gifts.map(s => <TableRow key={s._id}>
                        <TableCell>{s.name}</TableCell>
                        <TableCell>{s.reward}</TableCell>
                        <TableCell>{s.key}</TableCell>
                        <TableCell>{COMPARE[s.comparisionType]}</TableCell>
                        <TableCell>{s.value}</TableCell>
                        <TableCell>
                            <IconButton onClick={e => {
                                setId(s._id)
                                setKey(s.key)
                                setValue(s.value)
                                setDesc(s.desc)
                                setrewardName(s.name)
                                setComparisionType(s.comparisionType)
                                setType(1)
                                setReward(s.reward)
                                setShowDialog(true)
                            }}><Edit /></IconButton>
                            <IconButton onClick={e => {
                                if (window.confirm('Sure?')) {
                                    api.axios.get("/del/achievement/" + s._id)
                                        .then(d => {
                                            setRewards(gifts.filter(x => x._id !== s._id))
                                        })
                                }

                            }}><Delete /></IconButton>

                        </TableCell>


                    </TableRow>)}
                </TableBody>
            </Table>
        </div >
    )
}
